export default "__VITE_ASSET__C9QC59_2__"